import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Super admin pages don't load Turbo, so the preview posts the form itself and swaps in the rendered banner.
export default class extends Controller {
  static targets = ["output", "stale", "button"];
  static values = { url: String };

  markStale() {
    this.staleTarget.classList.remove("hidden");
  }

  async refresh(event) {
    event.preventDefault();

    const formData = new FormData(this.element);
    // The edit form carries _method=patch; the preview endpoint is a plain POST.
    formData.delete("_method");

    this.buttonTarget.disabled = true;
    try {
      const response = await post(this.urlValue, {
        body: formData,
        responseKind: "html",
      });
      if (!response.ok)
        throw new Error(`Preview failed with ${response.statusCode}`);

      this.outputTarget.innerHTML = await response.text;
      this.staleTarget.classList.add("hidden");
    } catch (error) {
      this.outputTarget.innerHTML =
        '<p class="text-sm text-destructive">The preview could not be loaded. Try again.</p>';
      throw error;
    } finally {
      this.buttonTarget.disabled = false;
    }
  }
}
